import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { useSelectedPointManager } from "hooks/useSelectedEntity";

export const PrivateOutlet = () => {
  const auth = useAuth();
  const location = useLocation();
  const selectedPointManager = useSelectedPointManager();

  return auth.access_token ? (
    <Outlet key={selectedPointManager?.id} />
  ) : (
    <Navigate to="/login" state={{ from: location }} />
  );
};
